import { throttle } from "es-toolkit/compat";
import React from "react";

import {
  ActiveUtterances,
  RefIntersectionMap,
} from "./ScrollManagerContext.decl";

const SCROLL_INTO_VIEW_THROTTLE_MS = 800;

export const scrollTo = throttle(
  (ref: React.RefObject<HTMLDivElement | null> | undefined) => {
    if (ref?.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center",
      });
    }
  },
  SCROLL_INTO_VIEW_THROTTLE_MS
);

export const isKaraokeOutOfView = (
  intersectionMap: RefIntersectionMap,
  activeList: ActiveUtterances
) => {
  const activeIndex = activeList[0];

  if (activeIndex !== undefined && intersectionMap.current.has(activeIndex)) {
    return !intersectionMap.current.get(activeIndex)?.intersecting;
  }

  // In case the active utterance is not initiated we don't want to take any other action and define it as "inView"
  return false;
};
